(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alpe-size-recommender"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alpe-size-recommender')) {
    class AlpeSizeRecommender extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return

        const configElement = this.querySelector('[data-alpe-size-config]')
        if (!configElement) {
          requestAnimationFrame(() => {
            if (this.isConnected) this.connectedCallback()
          })
          return
        }

        this.dataset.initialized = 'true'
        this.config = JSON.parse(configElement.textContent)
        try { const calibration = JSON.parse(this.config.fitCalibration || '{}'); this.config.fitCalibration = calibration && typeof calibration === 'object' && !Array.isArray(calibration) ? calibration : {} } catch { this.config.fitCalibration = {} }
        this.notificationOnly = this.config.profile === 'notify-only'
        this.chart = this.config.charts[this.config.profile] || { sizes: [], hardMetrics: [], mode: 'points' }
        this.dialog = this.querySelector('[data-alpe-size-dialog]')
        this.stage = this.querySelector('.alpe-size__stage')
        this.trigger = this.querySelector('[data-alpe-size-open]')
        this.stockCta = this.querySelector('[data-alpe-size-stock-cta]')
        this.stockCtaLabel = this.querySelector('[data-alpe-size-stock-cta-label]')
        this.measurementsForm = this.querySelector('[data-alpe-size-form]')
        this.fitForm = this.querySelector('[data-alpe-fit-form]')
        this.initialState = this.fitForm ? 'quick' : 'measurements'
        this.notifyForm = this.querySelector('[data-alpe-size-notify-form]')
        this.validation = this.querySelector('[data-alpe-size-validation]')
        this.badge = this.querySelector('[data-alpe-size-badge]')
        this.resultSize = this.querySelector('[data-alpe-size-result-size]')
        this.resultCopy = this.querySelector('[data-alpe-size-result-copy]')
        this.resultAlert = this.querySelector('[data-alpe-size-result-alert]')
        this.stockNote = this.querySelector('[data-alpe-size-stock-note]')
        this.selectButton = this.querySelector('[data-alpe-size-select]')
        this.notifyButton = this.querySelector('[data-alpe-size-notify]')
        this.backButton = this.querySelector('[data-alpe-size-back]')
        this.resultRestart = this.querySelector('.alpe-size__view--result [data-alpe-size-restart]')
        this.notifyProduct = this.querySelector('[data-alpe-size-notify-product]')
        this.notifyFormView = this.querySelector('[data-alpe-size-notify-form-view]')
        this.notifySuccess = this.querySelector('[data-alpe-size-notify-success]')
        this.notifyMessage = this.querySelector('[data-alpe-size-notify-message]')
        this.notifySubmit = this.querySelector('[data-alpe-size-notify-submit]')
        this.notifySuccessCopy = this.querySelector('[data-alpe-size-notify-success-copy]')
        this.section = this.closest('[data-section-type="product-template"], [data-alpe-product-scope]')
        this.views = Array.from(this.querySelectorAll('[data-alpe-size-view]'))
        this.sizeOptionIndex = this.findSizeOptionIndex()
        this.currentVariant = this.config.variants.find(variant => String(variant.id) === String(this.config.currentVariantId)) || null
        this.lastResult = null
        this.state = this.initialState
        this.notificationSource = 'size_recommender'
        this.notificationTarget = null
        this.notificationSessionId = 0
        this.notificationRequestInFlight = false
        this.notificationRequestCompleted = false
        this.returnFocusTarget = this.trigger
        this.resizeFrame = null
        this.dialogOpenFrame = null
        this.dialogCloseTimer = null
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.mobileTitleLayoutElements = new Set()
        this.titleResizeObserver = null
        this.visualViewport = window.visualViewport || null
        this.onResize = () => {
          if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame)
          this.resizeFrame = requestAnimationFrame(() => {
            this.updateScale()
            this.updateResultLayout()
            this.revealFocusedInput()
          })
        }
        this.onInputFocus = event => {
          if (!event.target.matches('.alpe-size__input-line input, .alpe-fit__input input, .alpe-size__notify-form input')) return
          requestAnimationFrame(() => {
            this.updateResultLayout()
            this.revealFocusedInput()
          })
        }
        this.onInputBlur = () => requestAnimationFrame(() => this.updateResultLayout())
        this.onVariantChange = event => {
          this.currentVariant = event.detail?.variant || null
          this.updateStockCta()
          if (this.lastResult && this.state !== 'notify') this.renderResult(false)
        }

        this.restoreBadge()
        this.bindEvents()
        this.updateStockCta()
        if ('ResizeObserver' in window) {
          this.titleResizeObserver = new ResizeObserver(() => {
            if (this.dialog?.open) this.updateResultLayout()
          })
          this.querySelectorAll('.alpe-size__product-title').forEach(title => this.titleResizeObserver.observe(title))
        }
        this.showState(this.initialState, false)
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.updateResultLayout()
        })
      }

      disconnectedCallback() {
        if (this.dialogOpenFrame) cancelAnimationFrame(this.dialogOpenFrame)
        if (this.dialogCloseTimer) clearTimeout(this.dialogCloseTimer)
        window.removeEventListener('resize', this.onResize)
        this.visualViewport?.removeEventListener('resize', this.onResize)
        this.visualViewport?.removeEventListener('scroll', this.onResize)
        this.dialog?.removeEventListener('focusin', this.onInputFocus)
        this.dialog?.removeEventListener('focusout', this.onInputBlur)
        this.titleResizeObserver?.disconnect()
        if (this.section) this.section.removeEventListener('variantChange', this.onVariantChange)
      }

      bindEvents() {
        this.trigger.addEventListener('click', () => this.open())
        this.fitForm?.addEventListener('submit', event => this.submitFit(event))
        this.fitForm?.addEventListener('input', event => {
          if (event.target.matches('.alpe-fit__input input')) event.target.setCustomValidity('')
          const message = this.querySelector('[data-alpe-fit-message]')
          if (message?.classList.contains('is-error')) {
            message.textContent = this.config.copy.betweenNote
            message.classList.remove('is-error')
          }
        })
        this.querySelector('[data-alpe-fit-advanced]')?.addEventListener('click', () => this.showState('measurements'))
        this.querySelector('[data-alpe-fit-quick]')?.addEventListener('click', () => this.showState('quick'))
        this.stockCta?.addEventListener('click', () => this.openNotifyForVariant(this.currentVariant))
        this.querySelector('[data-alpe-size-close]').addEventListener('click', () => this.closeDialog())
        this.querySelector('[data-alpe-size-guide]')?.addEventListener('click', () => this.showState('guide'))
        this.querySelector('[data-alpe-size-enter-measurements]').addEventListener('click', () => this.showState('measurements'))
        this.querySelectorAll('[data-alpe-size-restart]').forEach(button => {
          button.addEventListener('click', () => this.restart())
        })
        this.querySelectorAll('[data-alpe-size-back]').forEach(button => {
          button.addEventListener('click', () => this.closeDialog())
        })
        this.querySelector('[data-alpe-size-success-close]').addEventListener('click', () => this.closeDialog())
        this.measurementsForm.addEventListener('submit', event => this.submitMeasurements(event))
        this.selectButton.addEventListener('click', () => this.selectVariant())
        this.notifyButton.addEventListener('click', () => {
          this.openNotify(this.lastResult?.variant, 'size_recommender')
        })
        this.notifyForm.addEventListener('submit', event => this.submitNotification(event))
        this.notifyForm.elements.full_name.addEventListener('input', event => event.target.setCustomValidity(''))
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.closeDialog()
        })
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault()
          this.closeDialog()
        })
        this.dialog.addEventListener('close', () => this.afterClose())
        this.dialog.addEventListener('focusin', this.onInputFocus)
        this.dialog.addEventListener('focusout', this.onInputBlur)
        window.addEventListener('resize', this.onResize, { passive: true })
        this.visualViewport?.addEventListener('resize', this.onResize, { passive: true })
        this.visualViewport?.addEventListener('scroll', this.onResize, { passive: true })
        if (this.section) this.section.addEventListener('variantChange', this.onVariantChange)
      }

      open() {
        if (!this.openDialog(this.trigger)) return
        this.track('alpe:size_recommender_opened')
      }

      openDialog(returnFocusTarget = this.trigger) {
        if (this.dialog.open) return false
        this.returnFocusTarget = returnFocusTarget
        this.updateScale()
        this.dialog.classList.remove('is-open', 'is-closing')
        this.dialog.showModal()
        document.body.classList.add('alpe-size-open')
        const reveal = () => {
          this.dialogOpenFrame = null
          if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return
          this.dialog.classList.add('is-open')
          this.updateResultLayout()
          this.focusState()
        }
        if (this.prefersReducedMotion.matches) reveal()
        else this.dialogOpenFrame = requestAnimationFrame(reveal)
        return true
      }

      closeDialog() {
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return
        if (this.dialogOpenFrame) {
          cancelAnimationFrame(this.dialogOpenFrame)
          this.dialogOpenFrame = null
        }

        const finish = () => {
          this.dialogCloseTimer = null
          this.dialog.classList.remove('is-open', 'is-closing')
          if (this.dialog.open) this.dialog.close()
        }

        if (this.prefersReducedMotion.matches || !this.dialog.classList.contains('is-open')) {
          finish()
          return
        }

        this.dialog.classList.add('is-closing')
        this.dialog.classList.remove('is-open')
        this.dialogCloseTimer = window.setTimeout(finish, 220)
      }

      afterClose() {
        const closedNotificationTarget = this.notificationTarget
        if (this.dialogOpenFrame) cancelAnimationFrame(this.dialogOpenFrame)
        if (this.dialogCloseTimer) clearTimeout(this.dialogCloseTimer)
        this.dialogOpenFrame = null
        this.dialogCloseTimer = null
        this.dialog.classList.remove('is-open', 'is-closing')
        document.body.classList.remove('alpe-size-open')
        this.dialog.scrollTop = 0
        this.notifyForm.reset()
        this.notifyForm.removeAttribute('aria-busy')
        this.notifyForm.elements.full_name?.setCustomValidity('')
        this.notifyFormView.hidden = false
        this.notifySuccess.hidden = true
        this.notifySubmit.disabled = false
        if (this.state === 'notify' && this.lastResult) {
          if (closedNotificationTarget?.source === 'pdp_sold_out_cta') {
            this.lastResult = null
            this.showState(this.initialState, false)
          } else {
            this.renderResult(false)
          }
        }
        this.clearNotificationTarget()
        this.track('alpe:size_recommender_closed')
        const focusTarget = this.returnFocusTarget || this.trigger
        this.returnFocusTarget = this.trigger
        focusTarget?.focus({ preventScroll: true })
      }

      updateScale() {
        if (!this.stage || !this.dialog) return

        if (window.matchMedia('(max-width: 749px)').matches) {
          this.style.setProperty('--alpe-size-scale', '1')
          this.dialog.style.width = '100vw'
          this.dialog.style.maxWidth = '100vw'
          this.dialog.style.height = '100dvh'
          this.dialog.style.top = '0'
          this.dialog.style.left = '0'
          this.dialog.style.right = 'auto'
          this.dialog.style.bottom = 'auto'
          return
        }

        const scale = Math.min(1, (window.innerWidth - 40) / 1001, (window.innerHeight - 40) / 610)
        this.style.setProperty('--alpe-size-scale', String(Math.max(0.5, scale)))
        this.dialog.style.width = `${1001 * scale}px`
        this.dialog.style.height = `${610 * scale}px`
        this.dialog.style.top = '0'
        this.dialog.style.left = '0'
        this.dialog.style.right = '0'
        this.dialog.style.bottom = '0'
      }

      revealFocusedInput() {
        if (!window.matchMedia('(max-width: 749px)').matches || !this.dialog?.open) return

        const input = this.dialog.querySelector('.alpe-size__input-line input:focus, .alpe-fit__input input:focus, .alpe-size__notify-form input:focus')
        if (!input) return

        const viewportTop = this.visualViewport?.offsetTop || 0
        const viewportHeight = this.visualViewport?.height || window.innerHeight
        const dialogRect = this.dialog.getBoundingClientRect()
        const inputRect = input.getBoundingClientRect()
        const visibleTop = Math.max(dialogRect.top, viewportTop) + 16
        const visibleBottom = Math.min(dialogRect.bottom, viewportTop + viewportHeight) - 16

        if (inputRect.top >= visibleTop && inputRect.bottom <= visibleBottom) return

        const centeredOffset = (visibleBottom - visibleTop - inputRect.height) / 2
        const targetScroll = this.dialog.scrollTop + inputRect.top - visibleTop - centeredOffset
        this.dialog.scrollTo({ top: Math.max(0, targetScroll), behavior: 'auto' })
      }

      resetResultLayout() {
        [
          this.resultAlert,
          this.stockNote,
          this.selectButton,
          this.notifyButton,
          this.backButton,
          this.resultRestart
        ].forEach(element => element?.style.removeProperty('top'))
        this.stage?.style.removeProperty('min-height')
      }

      resetMobileTitleLayout() {
        this.mobileTitleLayoutElements.forEach(element => element.style.removeProperty('top'))
        this.mobileTitleLayoutElements.clear()
      }

      updateMobileTitleLayout() {
        if (!window.matchMedia('(max-width: 749px)').matches || !this.dialog?.open) return

        const currentView = this.views.find(view => !view.hidden)
        const title = currentView?.querySelector('.alpe-size__product-title')
        if (!title || title.getClientRects().length === 0) return

        const selectors = {
          quick: [
            '.alpe-size__heading',
            '.alpe-size__intro',
            '.alpe-fit__fields',
            '.alpe-fit__fit',
            '.alpe-fit__note',
            '.alpe-size__button--fit',
            '.alpe-fit__switch'
          ],
          measurements: [
            '.alpe-size__heading',
            '.alpe-size__intro',
            '.alpe-size__fields',
            '.alpe-size__measurement-note',
            '.alpe-size__button--measurements',
            '.alpe-size__links'
          ],
          result: [
            '.alpe-size__heading',
            '.alpe-size__result-size',
            '.alpe-size__result-copy',
            '.alpe-size__result-alert',
            '.alpe-size__stock-note',
            '.alpe-size__button--select',
            '.alpe-size__button--notify',
            '.alpe-size__button--back',
            '.alpe-size__restart'
          ],
          notify: [
            '.alpe-size__heading',
            ".alpe-size__notify-form input[name='full_name']",
            ".alpe-size__notify-form input[name='email']",
            '.alpe-size__button--send',
            '.alpe-size__notify-note',
            '.alpe-size__notify-success p',
            '.alpe-size__button--success'
          ]
        }
        const viewName = currentView.dataset.alpeSizeView
        const followers = Array.from(new Set((selectors[viewName] || []).flatMap(selector => {
          return Array.from(currentView.querySelectorAll(selector))
        }))).filter(element => element.getClientRects().length > 0)
        const heading = followers.find(element => element.classList.contains('alpe-size__heading'))
        if (!heading) return

        const titleHeight = Math.max(title.offsetHeight, title.scrollHeight)
        const shift = Math.max(0, Math.ceil(title.offsetTop + titleHeight + 10 - heading.offsetTop))
        if (shift > 0) {
          followers.forEach(element => {
            element.style.top = `${Math.ceil(element.offsetTop + shift)}px`
            this.mobileTitleLayoutElements.add(element)
          })
        }

        if (viewName === 'measurements' || viewName === 'quick') {
          const quick = viewName === 'quick'
          const note = currentView.querySelector(quick ? '.alpe-fit__note' : '.alpe-size__measurement-note')
          const button = currentView.querySelector(quick ? '.alpe-size__button--fit' : '.alpe-size__button--measurements')
          const guide = currentView.querySelector(quick ? '.alpe-fit__switch' : '.alpe-size__links')
          const placeAfter = (element, previous) => {
            if (!element || element.getClientRects().length === 0 || !previous) return
            const minimumTop = previous.offsetTop + previous.offsetHeight + 10
            if (element.offsetTop >= minimumTop) return
            element.style.top = `${Math.ceil(minimumTop)}px`
            this.mobileTitleLayoutElements.add(element)
          }
          placeAfter(button, note)
          placeAfter(guide, button)
        }

        const contentBottom = followers.reduce((bottom, element) => {
          return Math.max(bottom, element.offsetTop + element.offsetHeight)
        }, title.offsetTop + title.offsetHeight)
        const currentMinimum = Number.parseFloat(this.stage.style.minHeight) || 0
        this.stage.style.minHeight = `${Math.max(this.dialog.clientHeight, currentMinimum, Math.ceil(contentBottom))}px`
      }

      updateResultLayout() {
        this.resetMobileTitleLayout()
        this.resetResultLayout()
        const isMobileResult = window.matchMedia('(max-width: 749px)').matches && this.state.startsWith('result-')

        if (isMobileResult) {
          const minimumGap = 10
          const baseTop = element => Number.parseFloat(getComputedStyle(element).top) || 0
          const placeAfter = (element, previous) => {
            if (!element || element.hidden || !previous) return previous
            const top = Math.max(baseTop(element), previous.offsetTop + previous.offsetHeight + minimumGap)
            element.style.top = `${Math.ceil(top)}px`
            return element
          }

          const detail = this.state === 'result-available'
            ? (this.resultAlert.hidden ? null : this.resultAlert)
            : (this.stockNote.hidden ? null : this.stockNote)
          let lastElement = detail ? placeAfter(detail, this.resultCopy) : this.resultCopy

          const primaryButton = !this.selectButton.hidden
            ? this.selectButton
            : (!this.notifyButton.hidden ? this.notifyButton : (!this.backButton.hidden ? this.backButton : null))
          lastElement = placeAfter(primaryButton, lastElement)

          if (primaryButton !== this.backButton && !this.backButton.hidden) {
            lastElement = placeAfter(this.backButton, lastElement)
          }

          lastElement = placeAfter(this.resultRestart, lastElement)
          if (lastElement) {
            const contentHeight = Math.ceil(lastElement.offsetTop + lastElement.offsetHeight + 20)
            this.stage.style.minHeight = `${Math.max(this.dialog.clientHeight, contentHeight)}px`
          }
        }

        this.updateMobileTitleLayout()
      }

      showState(state, shouldFocus = true) {
        this.state = state
        this.dataset.state = state
        // Osnovno (quick) ali napredno (measurements) merjenje – rezultat in obveščanje ohranita postavitev izbranega načina.
        if (state === 'quick' || state === 'measurements') this.dataset.mode = state
        const viewName = state.startsWith('result-') ? 'result' : state
        this.views.forEach(view => {
          view.hidden = view.dataset.alpeSizeView !== viewName
        })
        const currentView = this.views.find(view => view.dataset.alpeSizeView === viewName)
        const heading = currentView?.querySelector('.alpe-size__heading')
        if (heading?.id) this.dialog.setAttribute('aria-labelledby', heading.id)
        this.updateScale()
        this.updateResultLayout()
        requestAnimationFrame(() => this.updateResultLayout())
        if (shouldFocus && this.dialog.open) requestAnimationFrame(() => this.focusState())
      }

      focusState() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches
        const closeButton = () => this.querySelector('[data-alpe-size-close]')
        const targets = {
          quick: () => isMobile ? closeButton() : this.fitForm?.elements.height,
          measurements: () => isMobile ? closeButton() : this.measurementsForm.querySelector('input'),
          guide: () => this.querySelector('[data-alpe-size-enter-measurements]'),
          'result-available': () => this.selectButton,
          'result-unavailable': () => this.notifyButton.hidden ? this.backButton : this.notifyButton,
          notify: () => this.notifySuccess.hidden
            ? (isMobile ? closeButton() : this.notifyForm.querySelector('input'))
            : this.querySelector('[data-alpe-size-success-close]')
        }
        const target = targets[this.state]?.()
        if (target) target.focus({ preventScroll: true })
      }

      submitFit(event) {
        event.preventDefault()
        const message = this.querySelector('[data-alpe-fit-message]')
        const readNumber = input => {
          const value = Number(String(input.value).trim().replace(',', '.'))
          const min = Number(input.dataset.min), max = Number(input.dataset.max)
          input.setCustomValidity(Number.isFinite(value) && value >= min && value <= max ? '' : `${min}–${max}`)
          return value
        }
        const height = readNumber(this.fitForm.elements.height)
        const weight = readNumber(this.fitForm.elements.weight)
        if (!this.fitForm.checkValidity() || !window.AlpeFit) {
          message.textContent = this.config.copy.invalid
          message.classList.add('is-error')
          this.fitForm.reportValidity()
          return
        }
        const fit = new FormData(this.fitForm).get('fit') || 'regular'
        const result = window.AlpeFit.recommend({height, weight, fit, profile: this.config.profile, chart: this.chart, calibration: this.config.fitCalibration, gender: this.config.gender})
        if (!result || result.outOfRange) {
          message.textContent = this.config.copy.quickOutside
          message.classList.add('is-error')
          return
        }
        message.textContent = this.config.copy.betweenNote
        message.classList.remove('is-error')
        this.lastResult = {...result, spread: 0, variant: null, method: 'height-weight-fit'}
        this.renderResult(true)
      }

      submitMeasurements(event) {
        event.preventDefault()
        const values = this.getMeasurementValues()

        if (!this.measurementsForm.checkValidity() || !values) {
          this.validation.textContent = this.config.copy.invalid
          this.validation.classList.add('is-error')
          this.measurementsForm.reportValidity()
          return
        }

        this.validation.textContent = this.config.copy.betweenNote
        this.validation.classList.remove('is-error')

        const metricResults = this.chart.hardMetrics.map(key => {
          if (this.chart.mode === 'upper-bounds') {
            return this.mapUpperBoundMetric(values[key], this.chart[key], this.chart.minimums[key])
          }
          return this.mapMetric(values[key], this.chart[key])
        })
        const indices = metricResults.map(result => result.index)
        const index = Math.max(...indices)
        const spread = Math.max(...indices) - Math.min(...indices)
        const outOfRange = metricResults.some(result => result.outOfRange)

        this.lastResult = {
          size: this.chart.sizes[index],
          spread,
          outOfRange,
          variant: null
        }
        this.renderResult(true)
      }

      getMeasurementValues() {
        const values = {}
        let valid = true
        new FormData(this.measurementsForm).forEach((value, key) => {
          const number = Number(String(value).trim().replace(',', '.'))
          if (!Number.isFinite(number) || number <= 0) valid = false
          values[key] = number
        })
        return valid ? values : null
      }

      mapMetric(value, anchors) {
        if (value < anchors[0]) return { index: 0, outOfRange: true }
        const lastIndex = anchors.length - 1
        if (value > anchors[lastIndex]) return { index: lastIndex, outOfRange: true }
        return { index: anchors.findIndex(anchor => value <= anchor), outOfRange: false }
      }

      mapUpperBoundMetric(value, upperBounds, minimum) {
        if (value < minimum) return { index: 0, outOfRange: true }
        const index = upperBounds.findIndex(bound => bound === null || value <= bound)
        if (index !== -1) return { index, outOfRange: false }
        return { index: upperBounds.length - 1, outOfRange: true }
      }

      renderResult(trackResult = false) {
        if (!this.lastResult) return
        const { size, spread, outOfRange } = this.lastResult
        const variant = this.resolveVariant(size)
        const missing = !variant
        const available = Boolean(variant && variant.available)
        const warnings = []

        if (this.chart.estimatedSizes?.includes(size)) warnings.push(this.config.copy.estimatedGrade)
        if (spread > 1) warnings.push(this.config.copy.conflict)
        if (outOfRange) warnings.push(this.config.copy.outOfRange)
        const warningCopy = warnings.join(' ')

        this.lastResult.variant = variant
        this.resultSize.textContent = variant ? this.getVariantSize(variant) : size
        this.resultCopy.textContent = available ? this.config.copy.result : this.config.copy.resultUnavailable
        this.resultAlert.textContent = warningCopy
        this.resultAlert.hidden = !available || warnings.length === 0
        this.dataset.warning = warnings.length ? 'true' : 'false'
        this.selectButton.hidden = !available
        this.selectButton.setAttribute('aria-label', this.interpolate(this.config.copy.selectLabel, size))
        this.notifyButton.hidden = available || missing
        this.backButton.hidden = available
        this.stockNote.hidden = available
        this.notifyButton.disabled = missing
        this.notifyButton.textContent = this.interpolate(this.config.copy.notify, size)
        const stockCopy = missing
          ? this.interpolate(this.config.copy.variantMissing, size)
          : this.interpolate(this.config.copy.unavailable, size)
        this.stockNote.textContent = warningCopy && !available ? `${stockCopy} ${warningCopy}` : stockCopy
        this.updateNotifyProduct(size)

        this.showState(available ? 'result-available' : 'result-unavailable')

        if (trackResult) {
          this.saveBadge(variant ? this.getVariantSize(variant) : size)
          if (variant && !this.applyRecommendedSize(size)) this.showSelectionError()
          this.track('alpe:size_recommendation_generated', {
            recommended_size: size,
            out_of_range: outOfRange,
            needs_review: spread > 1,
            available,
            variant_id: variant ? String(variant.id) : null
          })
        }
      }

      findSizeOptionIndex() {
        const names = this.config.productOptions || []
        const namedIndex = names.findIndex(name => /velikost|size|größe|taille|taglia|talla|tamanho/i.test(name))
        if (namedIndex !== -1) return namedIndex

        const sizes = new Set(this.chart.sizes.map(size => this.normalize(size)))
        let bestIndex = -1
        let bestMatches = 0
        names.forEach((name, index) => {
          const values = new Set(this.config.variants.map(variant => this.normalize(variant.options[index])))
          const matches = Array.from(values).filter(value => sizes.has(value)).length
          if (matches > bestMatches) {
            bestMatches = matches
            bestIndex = index
          }
        })
        return bestIndex === -1 && names.length === 1 ? 0 : bestIndex
      }

      selectedOptionValues() {
        const values = Array(this.config.productOptions.length).fill(null)
        if (this.section) {
          this.section.querySelectorAll('[data-variant-input]').forEach(input => {
            const optionIndex = Number(String(input.dataset.index || '').replace('option', '')) - 1
            if (optionIndex < 0 || optionIndex >= values.length) return
            const choice = input.type === 'radio' || input.type === 'checkbox'
            if (!choice || input.checked) values[optionIndex] = input.value
          })
        }

        const fallback = this.currentVariant || this.config.variants.find(variant => variant.available) || this.config.variants[0]
        return values.map((value, index) => value === null ? fallback?.options[index] : value)
      }

      getVariantSize(variant) {
        if (this.notificationOnly && variant) return variant.title === 'Default Title' ? this.config.productTitle : variant.title
        if (!variant || this.sizeOptionIndex < 0) return ''
        return variant.options[this.sizeOptionIndex] || ''
      }

      updateNotifyProduct(size) {
        const title = this.config.displayProductTitle || this.config.productTitle
        this.notifyProduct.textContent = size === this.config.productTitle ? title : `${title} (${size})`
      }

      updateStockCta() {
        if (!this.stockCta || !this.stockCtaLabel) return

        const size = this.getVariantSize(this.currentVariant)
        const shouldShow = Boolean(this.currentVariant && !this.currentVariant.available && size)
        this.stockCta.hidden = !shouldShow
        this.stockCta.disabled = !shouldShow

        if (!shouldShow) {
          this.stockCtaLabel.textContent = ''
          this.stockCta.removeAttribute('aria-label')
          return
        }

        const label = this.notificationOnly ? this.config.copy.notifyGeneric : this.interpolate(this.config.copy.notify, size)
        this.stockCtaLabel.textContent = label
        this.stockCta.setAttribute('aria-label', label)
      }

      resolveVariant(size) {
        if (this.sizeOptionIndex < 0) return null
        const options = this.selectedOptionValues()
        options[this.sizeOptionIndex] = size
        return this.config.variants.find(variant => {
          return variant.options.every((value, index) => this.normalize(value) === this.normalize(options[index]))
        }) || null
      }

      applyRecommendedSize(size) {
        const variant = this.resolveVariant(size)
        if (!variant) return false
        const group = this.section?.querySelector(`.variant-input-wrap[data-index="option${this.sizeOptionIndex + 1}"]`)
        const select = group?.querySelector('select[data-variant-input]')
        const radio = Array.from(group?.querySelectorAll('input[data-variant-input]') || []).find(input => this.normalize(input.value) === this.normalize(size))
        const selector = select || radio
        if (!selector) return false
        const changed = select ? select.value !== variant.options[this.sizeOptionIndex] : !radio.checked
        if (select) select.value = variant.options[this.sizeOptionIndex]
        if (radio) radio.checked = true
        if (changed) selector.dispatchEvent(new Event('change', { bubbles: true }))
        return String(this.section?.querySelector('[data-product-select]')?.value) === String(variant.id)
      }

      selectVariant() {
        if (!this.lastResult) return
        const variant = this.resolveVariant(this.lastResult.size)
        if (!variant || !variant.available) {
          this.lastResult.variant = variant
          this.renderResult(false)
          return
        }

        if (!this.applyRecommendedSize(this.lastResult.size)) {
          this.showSelectionError()
          return
        }
        this.saveBadge(this.lastResult.size)
        this.track('alpe:size_recommended_variant_selected', {
          recommended_size: this.lastResult.size,
          variant_id: String(variant.id)
        })
        this.closeDialog()
      }

      showSelectionError() {
        this.resultAlert.textContent = this.config.copy.selectionError
        this.resultAlert.hidden = false
        this.dataset.warning = 'true'
        this.updateResultLayout()
        requestAnimationFrame(() => this.updateResultLayout())
        this.track('alpe:size_variant_selection_error', {
          recommended_size: this.lastResult?.size || null,
          variant_id: this.lastResult?.variant ? String(this.lastResult.variant.id) : null
        })
      }

      openNotifyForVariant(variant) {
        const size = this.getVariantSize(variant)
        if (!variant || variant.available || !size || this.dialog.open || this.dialog.classList.contains('is-closing')) return

        if (!this.openDialog(this.stockCta)) return

        this.currentVariant = variant
        this.lastResult = {
          size,
          spread: 0,
          outOfRange: false,
          variant
        }

        if (!this.openNotify(variant, 'pdp_sold_out_cta')) {
          this.closeDialog()
          return
        }
        this.track('alpe:pdp_back_in_stock_cta_clicked', {
          selected_size: size,
          variant_id: String(variant.id)
        })
      }

      createNotificationTarget(variant, source) {
        const size = this.getVariantSize(variant)
        if (!variant || variant.available || !size) return null

        const normalizedSource = source === 'pdp_sold_out_cta' ? source : 'size_recommender'
        this.notificationSessionId += 1
        return Object.freeze({
          variant,
          variantId: String(variant.id),
          size,
          source: normalizedSource,
          sessionId: this.notificationSessionId
        })
      }

      syncNotificationTarget(target) {
        this.notificationTarget = target
        this.notificationSource = target.source
        this.notificationRequestInFlight = false
        this.notificationRequestCompleted = false
        this.notifyForm.dataset.variantId = target.variantId
        this.notifyForm.dataset.size = target.size
        this.notifyForm.dataset.source = target.source
        this.notifyForm.dataset.sessionId = String(target.sessionId)
        this.updateNotifyProduct(target.size)
      }

      clearNotificationTarget() {
        this.notificationTarget = null
        this.notificationSource = 'size_recommender'
        this.notificationRequestInFlight = false
        this.notificationRequestCompleted = false
        delete this.notifyForm.dataset.variantId
        delete this.notifyForm.dataset.size
        delete this.notifyForm.dataset.source
        delete this.notifyForm.dataset.sessionId
      }

      isNotificationTargetValid(target) {
        if (!target || this.notificationTarget !== target) return false
        if (!target.variant || target.variant.available || String(target.variant.id) !== target.variantId) return false
        if (this.normalize(this.getVariantSize(target.variant)) !== this.normalize(target.size)) return false
        return this.notifyForm.dataset.variantId === target.variantId
          && this.normalize(this.notifyForm.dataset.size) === this.normalize(target.size)
      }

      openNotify(variant = this.lastResult?.variant, source = 'size_recommender') {
        const target = this.createNotificationTarget(variant, source)
        if (!target || !this.lastResult) return false

        this.lastResult.size = target.size
        this.lastResult.variant = target.variant
        this.syncNotificationTarget(target)
        this.notifyFormView.hidden = false
        this.notifySuccess.hidden = true
        this.notifyForm.reset()
        this.notifySubmit.disabled = false
        this.notifySubmit.textContent = this.config.copy.notifySubmit
        this.notifyMessage.textContent = this.config.copy.notifyNote
        this.notifyMessage.classList.remove('is-error')
        this.showState('notify')
        this.track('alpe:size_back_in_stock_form_opened', {
          recommended_size: target.size,
          variant_id: target.variantId,
          source: target.source
        })
        return true
      }

      async submitNotification(event) {
        event.preventDefault()
        const target = this.notificationTarget
        if (this.notificationRequestInFlight || this.notificationRequestCompleted) return
        if (!this.isNotificationTargetValid(target)) {
          this.notifyMessage.textContent = this.config.copy.notifyError
          this.notifyMessage.classList.add('is-error')
          return
        }

        const { variant, variantId, size, source } = target
        this.updateNotifyProduct(size)

        const formData = new FormData(this.notifyForm)
        const fullName = String(formData.get('full_name') || '').trim().replace(/\s+/g, ' ')
        const email = String(formData.get('email') || '').trim().toLowerCase()
        const fullNameInput = this.notifyForm.elements.full_name
        fullNameInput.setCustomValidity('')
        if (fullName.split(' ').filter(Boolean).length < 2) {
          fullNameInput.setCustomValidity(this.config.copy.fullNameError)
        }

        if (!this.notifyForm.checkValidity()) {
          this.notifyMessage.textContent = fullNameInput.validationMessage || this.config.copy.notifyError
          this.notifyMessage.classList.add('is-error')
          this.notifyForm.reportValidity()
          return
        }

        const name = this.splitName(fullName)

        this.notificationRequestInFlight = true
        this.notifySubmit.disabled = true
        this.notifySubmit.textContent = this.config.copy.submitting
        this.notifyMessage.textContent = this.config.copy.notifyNote
        this.notifyMessage.classList.remove('is-error')
        this.notifyForm.setAttribute('aria-busy', 'true')

        try {
          await this.upsertKlaviyoProfile({ fullName, email, ...name, variant, size, source })
          await this.subscribeBackInStock({ email, variant })

          if (this.notificationTarget !== target) return
          this.notificationRequestCompleted = true
          this.notifyFormView.hidden = true
          this.notifySuccess.hidden = false
          this.dialog.setAttribute('aria-labelledby', this.querySelector('[data-alpe-size-notify-success] .alpe-size__heading').id)
          this.notifySuccessCopy.textContent = this.interpolate(this.config.copy.notifySuccess, size)
          this.saveBadge(size)
          this.updateResultLayout()
          this.track('alpe:size_back_in_stock_subscribed', {
            recommended_size: size,
            variant_id: variantId,
            source
          })
          requestAnimationFrame(() => this.querySelector('[data-alpe-size-success-close]').focus({ preventScroll: true }))
        } catch (error) {
          if (this.notificationTarget !== target) return
          this.notifyMessage.textContent = this.config.copy.notifyError
          this.notifyMessage.classList.add('is-error')
          this.notifySubmit.disabled = false
          this.notifySubmit.textContent = this.config.copy.notifySubmit
          this.track('alpe:size_back_in_stock_error', {
            recommended_size: size,
            variant_id: variantId,
            source
          })
        } finally {
          if (this.notificationTarget === target) {
            this.notificationRequestInFlight = false
            this.notifyForm.removeAttribute('aria-busy')
          }
        }
      }

      async upsertKlaviyoProfile({ fullName, email, firstName, lastName, variant, size, source }) {
        const payload = {
          data: {
            type: 'profile',
            attributes: {
              email,
              first_name: firstName,
              last_name: lastName,
              locale: this.config.locale,
              properties: {
                alpe_full_name: fullName,
                alpe_bis_source: source,
                alpe_last_product_id: String(this.config.productId),
                alpe_last_product_title: this.config.productTitle,
                alpe_last_product_url: this.config.productUrl,
                alpe_last_variant_id: String(variant.id),
                alpe_last_variant_title: variant.title,
                alpe_last_recommended_size: size,
                alpe_last_size_profile: this.config.profile
              }
            }
          }
        }
        await this.postKlaviyo('/client/profiles', payload)
      }

      async subscribeBackInStock({ email, variant }) {
        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variant.id}`
                }
              }
            }
          }
        }
        await this.postKlaviyo('/client/back-in-stock-subscriptions', payload)
      }

      async postKlaviyo(path, payload) {
        const companyId = encodeURIComponent(this.config.klaviyoSiteId)
        const response = await fetch(`https://a.klaviyo.com${path}?company_id=${companyId}`, {
          method: 'POST',
          headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            revision: this.config.klaviyoRevision
          },
          body: JSON.stringify(payload)
        })
        if (response.status !== 202) throw new Error(`Klaviyo request failed with ${response.status}`)
      }

      splitName(fullName) {
        const parts = fullName.split(' ').filter(Boolean)
        if (parts.length < 2) return { firstName: parts[0] || '', lastName: '' }
        return {
          firstName: parts.slice(0, -1).join(' '),
          lastName: parts[parts.length - 1]
        }
      }

      restart() {
        const mode = this.lastResult?.method === 'height-weight-fit' ? 'quick' : (this.dataset.mode || this.initialState)
        this.lastResult = null
        this.measurementsForm.reset()
        this.validation.textContent = this.config.copy.betweenNote
        this.validation.classList.remove('is-error')
        this.showState(this.fitForm ? mode : 'measurements')
      }

      saveBadge(size) {
        if (this.notificationOnly) return
        this.badge.textContent = `${this.config.copy.badge} ${size}`
        this.badge.hidden = false
        try {
          localStorage.setItem(this.storageKey(), size)
        } catch (error) {
          return
        }
      }

      restoreBadge() {
        try {
          const size = localStorage.getItem(this.storageKey())
          if (this.chart.sizes.some(value => this.normalize(value) === this.normalize(size))) {
            this.badge.textContent = `${this.config.copy.badge} ${size}`
            this.badge.hidden = false
            const restoreSelection = () => requestAnimationFrame(() => {
              if (this.isConnected && !new URL(location.href).searchParams.has('variant')) this.applyRecommendedSize(size)
            })
            if (document.readyState !== 'loading') restoreSelection()
            else document.addEventListener('DOMContentLoaded', restoreSelection, { once: true })
          }
        } catch (error) {
          return
        }
      }

      storageKey() {
        return `alpe:size:v3:${this.config.productId}:${this.config.profile}`
      }

      normalize(value) {
        return String(value || '').trim().toUpperCase().replace(/^2XL$/, 'XXL').replace(/^XXXL$/, '3XL')
      }

      interpolate(template, size) {
        return String(template).split('__SIZE__').join(size)
      }

      track(event, detail = {}) {
        const payload = {
          event,
          product_id: String(this.config.productId),
          size_profile: this.config.profile,
          ...detail
        }
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(payload)
        document.dispatchEvent(new CustomEvent(event, { detail: payload }))
      }
    }

    customElements.define('alpe-size-recommender', AlpeSizeRecommender)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
